import { useState, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../services/firebase';

function CoachRoute({ children }) {
  const [user, loading] = useAuthState(auth);
  const [isCoach, setIsCoach] = useState(false);
  const [checkingRole, setCheckingRole] = useState(true);
  const [searchParams] = useSearchParams();
  const clubParam = searchParams.get('club');

  useEffect(() => {
    const checkCoachRole = async () => {
      if (!user) {
        setCheckingRole(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          // Allow coach, club_admin, or super_admin
          const hasCoachRole = userData.role === 'coach' || 
                               userData.role === 'club_admin' || 
                               userData.role === 'super_admin';
          setIsCoach(hasCoachRole);
        }
      } catch (error) {
        console.error('Error checking coach status:', error);
      } finally {
        setCheckingRole(false);
      }
    };

    if (user) {
      checkCoachRole();
    } else if (!loading) {
      setCheckingRole(false);
    }
  }, [user, loading]);

  if (loading || checkingRole) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-content">
          <span className="loading-icon">⚽</span>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login, preserving club param
    const loginUrl = clubParam ? `/login?club=${clubParam}` : '/login';
    return <Navigate to={loginUrl} replace />;
  }

  if (!isCoach) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-content">
          <span className="loading-icon">🚫</span>
          <h2>Access Denied</h2>
          <p>You do not have coach privileges for this club.</p>
          <a href={clubParam ? `/?club=${clubParam}` : '/'} className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
            Go Home
          </a>
        </div>
      </div>
    );
  }

  return children;
}

export default CoachRoute;
